let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("34r5V")).then(() => parcelRequire('bD7yN'));